import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface PesvViasInternasPayload {
  sede_id?: number | null;
  responsable_id?: number | null;
  codigo: string;
  nombre: string;
  tipo_via: string;
  descripcion?: string | null;
  longitud_m?: number | null;
  ancho_m?: number | null;
  numero_carriles?: number | null;
  sentido_circulacion?: string | null;
  tipo_superficie?: string | null;
  estado_superficie?: string | null;
  pendiente?: string | null;
  velocidad_maxima_kmh?: number | null;
  direccion?: string | null;
  departamento?: string | null;
  municipio?: string | null;
  latitud?: number | null;
  longitud?: number | null;
  estado?: number;
  created_by?: number | null;
  updated_by?: number | null;
}

/**
 * 🔹 Entidad
 */
export interface PesvViasInternas {
  id?: number;
  sede_id?: number | null;
  responsable_id?: number | null;
  codigo: string;
  nombre: string;
  tipo_via: string;
  descripcion?: string | null;
  longitud_m?: number | null;
  ancho_m?: number | null;
  numero_carriles?: number | null;
  sentido_circulacion?: string | null;
  tipo_superficie?: string | null;
  estado_superficie?: string | null;
  pendiente?: string | null;
  velocidad_maxima_kmh?: number | null;
  direccion?: string | null;
  departamento?: string | null;
  municipio?: string | null;
  latitud?: number | null;
  longitud?: number | null;
  estado: number;
  created_by?: number | null;
  updated_by?: number | null;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface PesvViasInternasResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class PesvViasInternasService {
  private readonly apiUrl = `${environment.apiUrl}/api/pesv_vias_internas`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todas las vías internas
   */
  getAll(): Observable<PesvViasInternas[]> {
    return this.http.get<PesvViasInternas[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  /**
   * Obtener vía interna por ID
   */
  getById(id: number): Observable<PesvViasInternas> {
    return this.http.get<PesvViasInternas>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear vía interna
   */
  create(
    payload: PesvViasInternasPayload
  ): Observable<PesvViasInternasResponse> {
    return this.http.post<PesvViasInternasResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar vía interna
   */
  update(
    id: number,
    payload: Partial<PesvViasInternasPayload>
  ): Observable<PesvViasInternasResponse> {
    return this.http.put<PesvViasInternasResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar vía interna
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar vía interna
   */
  inactivar(id: number): Observable<PesvViasInternasResponse> {
    return this.http.put<PesvViasInternasResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar vía interna
   */
  activar(id: number): Observable<PesvViasInternasResponse> {
    return this.http.put<PesvViasInternasResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  getActiveVias(): Observable<PesvViasInternas[]> {
    return this.http.get<PesvViasInternas[]>(`${this.apiUrl}/activos`, {
      withCredentials: true,
    });
  }
}